import eases from 'eases';
import tweeen from 'tweeen';

let stopScroll;

export default function scrollTo(y, { duration = 300, ...options } = {}) {
  if (stopScroll) {
    stopScroll();
  }

  return new Promise((resolve) => {
    stopScroll = tweeen(
      window.scrollY,
      y,
      (y) => {
        window.scrollTo(0, y);
      },
      {
        easing: eases.cubicInOut,
        duration,
        end: resolve,
        ...options,
      }
    );
  });
}
